<template>
  <li class="token">
    <div class="token-badge badge-js" @click="calcCoordinates">
      <div class="token-icon">
        <img v-if="token.icon" :src="tokenLogo" class="token-image" />
        <div
          v-if="token.color"
          :style="{ backgroundColor: token.color }"
          class="token-color"
        >
          <span class="name-short">{{ token.name }}</span>
        </div>
      </div>
    </div>
    <div
      class="token-badge-shadow"
      :class="{ correct: token.correct }"
      @click="returnToken"
    >
      <div class="token-icon">
        <img v-if="token.icon" :src="tokenLogo" class="token-image" />
        <div
          v-if="token.color"
          class="token-color"
          :style="{ backgroundColor: token.color }"
        >
          <span class="name-short">{{ token.name }}</span>
        </div>
      </div>
    </div>
    <h3 class="token-title">
      <span class="token-truncate">{{ token.name }}</span>
    </h3>

    <div
      v-if="token.removable"
      class="token-remove"
      @click="removeToken(token)"
    >
      –
    </div>
  </li>
</template>

<script>
import $ from "jquery";
import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import EventBus from "../eventBus";

gsap.registerPlugin(Draggable);

export default {
  name: "Token",

  props: {
    token: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  computed: {
    // add baseurl to image src, needed so images are pointing to right directory when build
    tokenLogo() {
      return this.baseUrl + this.token.icon;
    },
  },

  mounted() {
    this.$badge = $(this.$el).children(".badge-js");
    this.container = $("#app");

    // because the tokens are placed inside an scrollable div we need to create a clone
    // this allows the badge to be dragged outside of its container.
    this.$clone = this.$badge
      .clone()
      .addClass("clone")
      .prependTo(this.container);

    // when the clone is added to the dom make it draggable
    this.$clone.draggable = this.createDraggable(this.$clone);

    // when the original badge is dragged move the clone to that position and take over the event
    this.$badge.on("mousedown touchstart", this.$clone, this.startDraggable);

    // catch reset event
    EventBus.$on("resetToken", () => {
      this.returnToken();
    });
  },
  methods: {
    startDraggable(event) {
      // hide the original badge
      gsap.set(this.$badge, {
        autoAlpha: 0,
      });

      // show the clone and move to position of original badge
      gsap.set(this.$clone, {
        x: this.$badge.offset().left,
        y: this.$badge.offset().top,
        force3D: false,
        autoAlpha: 1,
      });

      // take over drag event
      this.$clone.draggable.startDrag(event.originalEvent);
    },

    createDraggable(clone) {
      // create draggable handler for clone
      clone.draggable = new Draggable(this.$clone, {
        type: "x, y",
        throwProps: true,
        bounds: "#app",
        onThrowComplete: () => this.calcCoordinates(),
        onDragEnd: () => {
          this.checkHit(clone.draggable);
          this.calcCoordinates();
        },
      });

      return clone.draggable;
    },

    // calculate the coordinates of the token relative to the coordinate-wrapper
    calcCoordinates() {
      // get width and height of the coordinate wrapper
      var canvasWidth = $(".coordinate-wrapper").outerWidth();
      var canvasHeight = $(".coordinate-wrapper").outerHeight();

      // get the offset
      var canvasOffset = $(".coordinate-wrapper").offset();

      // get the position of the token from its center point
      var positionBadgeX = this.getCenter(this.$clone)[0];
      var positionBadgeY = this.getCenter(this.$clone)[1];

      // convert badge position so its relative to the coordinate wrapper
      // left-right: 0-100 | top-bottom: 0-100
      var positionX = Math.round(
        ((positionBadgeX - canvasOffset.left) / canvasWidth) * 100
      );
      var positionY = Math.round(
        ((positionBadgeY - canvasOffset.top) / canvasHeight) * 100
      );

      // check if its placed at the correct position
      this.checkCoordinates(positionX, positionY);
    },

    // get position of badge from its center
    getCenter(element) {
      var $this = element;
      var offset = $this.offset();
      var width = $this.outerWidth();
      var height = $this.outerHeight();

      var centerX = offset.left + width / 2;
      var centerY = offset.top + height / 2;

      // return position
      return [centerX, centerY];
    },

    // check input position to config position
    checkCoordinates(x, y) {
      var correctX = this.token.positionX / 2 + 50;
      var correctY = this.token.positionY / 2 + 50;

      // add some margin to the correct position so its easier to succes
      if (Math.abs(correctX - x) <= 4 && Math.abs(correctY - y) <= 4) {
        this.tokenCorrect();
      } else {
        this.tokenInCorrect();
      }

      //console.log('x:'+ x, 'y:'+ y);
    },

    // check if the token is placed closed to a guide
    checkHit(element) {
      $(".token-guide").each(function () {
        var test = element.hitTest(this, "50%");

        // if test returns true move token to center of guide
        if (test) {
          var position = $(this).offset();

          // get size of token and devide to get center
          var widthToken = $(element.target).outerWidth() / 2;
          var heightToken = $(element.target).outerHeight() / 2;

          // get size of guide and devide to get center
          var widthGuide = $(this)[0].getBoundingClientRect().width / 2;
          var heightGuide = $(this)[0].getBoundingClientRect().height / 2;

          // animate position
          gsap.to(element.target, 0.4, {
            x: position.left + widthGuide - widthToken,
            y: position.top + heightGuide - heightToken,
            ease: "expo.easeOut",
          });
        }
      });
    },

    // if token is places correctly fire event
    tokenCorrect() {
      // if token was correct and moved but still correct dont fire event
      if (this.token.correct) return;
      EventBus.$emit("tokenSucces");
      this.token.correct = true;
    },

    tokenInCorrect() {
      this.token.correct = false;
    },

    // move token back to original position
    returnToken() {
      gsap.to(this.$clone, 0.5, {
        x: this.$badge.offset().left,
        y: this.$badge.offset().top,
        ease: "power4.easeInOut",
        onComplete: () => this.returnTokenCompete(),
      });
    },

    returnTokenCompete() {
      gsap.set(this.$clone, {
        autoAlpha: 0,
        y: 0,
        x: 0,
      });
      gsap.set(this.$badge, {
        autoAlpha: 1,
      });
      this.tokenInCorrect();
    },

    // remove custom token
    removeToken() {
      if (confirm("Weet u zeker dat u de partij wilt verwijderen?")) {
        let index = $(this.$el).index() - 1;
        EventBus.$emit("removeToken", index);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.token-badge,
.token-badge-shadow {
  width: 4vw;
  height: 4vw;
  border-radius: 100%;
  margin: 0 auto;
  overflow: hidden;
  user-select: none;
  box-sizing: border-box;
}

.clone {
  position: absolute !important;
  opacity: 0;
  top: 0;
  left: 0;
  visibility: hidden;
}

.token-badge {
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.19);
  position: relative;
  z-index: 1;
  background-color: white;
}

.token {
  width: 50%;
  margin: 10px 0;
  display: inline-block;
  position: relative;
  float: left;
}

.token-badge-shadow {
  position: absolute;
  top: 0;
  left: 50%;
  border: 2px solid rgba(0, 0, 0, 0.1);
  transform: scale(0.99) translateX(-50%);

  .token-color,
  .token-image {
    opacity: 0.3;
  }

  &:after {
    content: "👍";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 1.5vw;
    line-height: 4vw;
    background-color: $cerulean;
    transform: scale(0);
    transition: transform 0.5s;
    border-radius: 100%;
    box-sizing: border-box;
  }

  &.correct {
    border: 0 solid $cerulean;
    &:after {
      transform: scale(1);
    }
  }
}

.token-title {
  font-size: 10px;
  text-align: center;
  padding-top: 8px;
  font-weight: $font-regular;
  position: relative;
}

.token-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.token-icon {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}

.token-image {
  width: 60%;
  height: 60%;
  object-fit: contain;
}

.token-color {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 80%;
  border-radius: 100%;
}

.name-short {
  color: white;
  width: 75%;
  text-align: center;
  font-size: 8px;
  position: absolute;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

.token-remove {
  width: 13px;
  height: 13px;
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 0.5vw;
  z-index: 100;
  border-radius: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.5s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
}

.token-truncate {
  width: 100%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
